'use strict'

export const padding = ['', 'small', 'large', 'flush']
